import { TOKEN_MAP } from '@/src/constants';
import { useNetwork } from '@/src/contexts';
import { useMemo } from 'react';

/**
 * Custom hook to get tokens for the current network
 *
 * @returns tokens for the current network
 */
export const useTokens = () => {
  const { network } = useNetwork();
  const tokens = useMemo(() => TOKEN_MAP[network] || [], [network]);
  return tokens;
};
